<template>
  <div class="chartOne">
    <div class="titleall">
      <h6 class="title" :style="themetype == 'chalk' ? 'color:#fff' : ''">{{ chartTitle }}</h6>
      <span class="tspan">{{ chartUnit }}</span>
    </div>
    <div :id="codMain" class="codMain"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    codMain: String,
    ChartData: Object,
    firstindex: Number
  },
  data() {
    return {
      themetype: null,
      one: this.ChartData,
      myChart: null,
      timer: null,
      codChart: null,
      chartData: {},
      seriesData: [],
      openIndex: null,
      chartTitle: "",
      chartUnit: "",
      initOption: {
        backgroundColor: '',
        animation: true,
        animationDuration: 1500,
        dataZoom: [
          {
            type: "inside",
          },
        ],
        legend: {
          data: "",
          itemHeight: 11,
          itemWidth: 22,
          textStyle: {
            color: 'rgba(158, 158, 158, 1)',
            rich: {
              a: {
                verticalAlign: "middle",
              },
            },
            padding: [0, 0, -2, 0], //[上、右、下、左]
          },
          // orient: 'vertical',  //垂直显示
          // y: 'center',    //延Y轴居中
          // x: 'right' //居右显示
        },
        grid: {
          top: "12%",
          left: "3%",
          right: "4%",
          bottom: "13%",
          containLabel: true,
        },
        // toolbox: {
        //   show: true,
        //   feature: {
        //     /* line是折线图，bar是柱形图*/
        //     magicType: { show: true, type: ['line', 'bar'] },
        //   }
        // },
        xAxis: {
          type: "category",
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          }
        },
        tooltip: {
          confine: true,
          trigger: "axis", // 当鼠标移动到坐标轴时触发
          axisPointer: {
            type: "line",
            z: 0,
            lineStyle: {
              color: "#40E0D0",
            },
          },
          textStyle: {
            align: "left",
          },
          extraCssText: "z-index: 99999",
        },
        series: [
          {
            name: "",
            data: "",
            symbol: "none", //去掉折线图中的节点
            smooth: true, //true 为平滑曲线，false为直线
            lineStyle: { width: 1.6 },
            type: "line",
            label: {
              show: false, // 是否显示文字
              position: "right", // 文字位置
            },
            itemStyle: {
              lineStyle: {
                color: '"#40E0D0"', //改变折线颜色
                width: 1.2,
              },
            },
            zlevel: 999,
          },
        ],
      },
    };
  },
  beforeDestroy() {
    //2.销毁前清除定时器
    // this.myChart.clear()

    clearInterval(this.timer);
  },
  mounted() {
    let theme = localStorage.getItem("theme")
      ? JSON.parse(localStorage.getItem("theme"))
      : "light";
    this.themetype = theme == "dark" ? 'chalk' : 'no';
    this.initChart();
    this.timer = window.setInterval(() => {
      setTimeout(this.initChart(), 0);
    }, 300000);
    window.addEventListener("resize", () => {
      this.codChart.resize();
    });
  },
  computed: {
    ...mapState(["theme"]),
  },
  watch: {
    "$store.state.open"(newVal, oldVal) {
      this.$nextTick(() => {
        // this.codChart.resize();
        setTimeout(() => {
          console.log(this.codChart);
          this.codChart.resize();
        }, 10);
      });
    },
    ChartData(newval) {
      this.codChart.clear();
      if (newval) {
        this.initChart();
      }
    },
    theme(newval) {
      // console.log("nidaye");
      this.themetype = newval
      this.codChart.dispose();
      this.initChart();
    },
  },
  methods: {
    initChart() {
      console.log(this.ChartData);
      this.chartTitle = this.ChartData.title;
      // console.log(this.chartTitle);
      this.chartUnit = this.ChartData.legend[0].unit;
      if (this.chartUnit == '-') {
        this.chartUnit = ''
      }
      this.initOption.xAxis.data = this.ChartData.xAxis;
      this.initOption.yAxis = []
      this.initOption.series = []
      //   const legendData = this.ChartData.legend.map((item) => {
      //     return item.name;
      //   });
      //   this.initOption.legend.data = legendData;
      let selected_item = {};
      this.ChartData.legend.map((item, index, array) => {
        var key_name = item.name;
        // if (index > 1) {
        //   selected_item[key_name] = false;
        // } else {
        //   selected_item[key_name] = true;
        // }
        this.initOption.title = {
          left: "center",
          text: this.chartTitle,
          show: false,
        };
        this.initOption.yAxis = [
          {
            type: "value",
            splitLine: {
              show: false
            }
          },
        ];
        // if (index === 0) {
        //   this.initOption.series[index] = {
        //     name: item.name,
        //     data: item.yAxis,
        //     symbol: "none",
        //     smooth: false,
        //     lineStyle: { width: 1.6 },
        //     type: "line",
        //     label: {
        //       show: false,
        //       position: "right",
        //     },
        //     itemStyle: {
        //       normal: {
        //         color: '#498AF4', //改变折线点的颜色
        //         lineStyle: {
        //           color: '#498AF4',//改变折线颜色

        //         }
        //       }
        //     },
        //   };
        // } else {
        // console.log(item);
        this.initOption.series[index] = {
          name: item.name,
          data: item.yAxis,
          symbol: "none", //去掉折线图中的节点
          smooth: false, //true 为平滑曲线，false为直线
          lineStyle: { width: 1.6 },
          type: "line",
          // yAxisIndex: index,
          label: {
            show: false, // 是否显示文字
            position: "right", // 文字位置
          },

        };
        // }
      });
      if (this.firstindex == 0) {

        this.initOption.legend.selected = selected_item;
      }
      console.log(this.initOption);
      let newPromise = new Promise((resolve) => {
        resolve();
      });
      newPromise.then(() => {
        // console.log(this.theme);
        this.myChart = this.$echarts.init(
          document.getElementById(this.codMain),
          this.theme
        ); // 使用dark 、light或无第二参数
        // console.log(myChart);
        this.myChart.setOption(this.initOption);
        this.codChart = this.$echarts.init(
          document.getElementById(this.codMain)
        );
        if (this.codChart == null) {
          this.codChart = this.$echarts.init(
            document.getElementById(this.codMain)
          );
        }
        this.codChart.clear();
        this.codChart.setOption(this.initOption);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.chartOne {
  width: 100%;
  margin: 0 auto;
  border-radius: 16px;
  overflow-y: hidden;

  .titleall {
    text-align: center;

    .title {
      display: inline-block;
      font-weight: 500;
      font-size: 18px;
      margin: 9px;
      margin-right: 10px;
    }

    .tspan {
      color: #a6a6a6;
    }
  }

  ::-webkit-scrollbar {
    border-radius: 6px;
    width: 5px !important;
    background-color: #ccc;
  }

  ::-webkit-scrollbar-thumb {
    //滑块部分
    border-radius: 6px;
    background-color: #989898;
    height: 30px;
  }

  .codMain {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    z-index: 99;
  }

  h6 {
    padding-left: 36px;
    text-align: left;
    font-size: 12px;
    color: rgb(76, 76, 76);
    font-weight: 600;
  }
}
</style>
